import { BUTTON_ICON_SIZE_MEDIUM_DESKTOP, BUTTON_ICON_SIZE_MEDIUM_MOBILE } from '../Sections/Profile/Buttons';

const collapsedPadding = 16;
const collapsedPaddingOffscreen = collapsedPadding + 10;

const spacingTight = 20;

export const tokens = {
    zindex: {
        // TODO: We should not be defining arbitrary z-index values.
        // This number has been chosen so that it sits above the `GroupsNavigation`.
        temp: 201,
    },
    spacing: {
        tight: spacingTight,
        loose: spacingTight * 2,
    },
    collapsed: {
        padding: {
            base: collapsedPadding,
            offscreen: collapsedPaddingOffscreen,
            edge: collapsedPadding + collapsedPaddingOffscreen,
        },
        height: {
            tablet: 480,
        },
    },
    sheet: {
        width: {
            thin: 420,
            medium: 640,
            wide: 1040,
        },
    },
    card: {
        radius: 30,
    },
    header: {
        // TODO: These sizes should be based on <CloseAction />.
        height: {
            mobile: spacingTight * 2 + BUTTON_ICON_SIZE_MEDIUM_MOBILE,
            desktop: spacingTight * 2 + BUTTON_ICON_SIZE_MEDIUM_DESKTOP,
        },
    },
    layout: {
        secondary: {
            width: 280,
        },
    },
};
